<template>
  <div class="app-embed--youtube">
    <div
      v-if="attributes.oembed"
      v-html="attributes.oembed"
    />

    <!-- Make custom iframe with url if no embed is provided-->
    <iframe
      v-else
      :title="attributes.title"
      :src="attributes.url"
      frameborder="0"
      allow="
        accelerometer;
        autoplay;
        clipboard-write;
        encrypted-media;
        gyroscope;
        picture-in-picture;
        web-share;
      "
      referrerpolicy="strict-origin-when-cross-origin"
      allowfullscreen
    />
  </div>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import type { EmbedAttributes } from '~/types/components/Embed';

  export default defineNuxtComponent({
    name: 'YoutubeEmbed',

    props: {
      elem: {
        type: Object as PropType<TContent<EmbedAttributes>>,
        required: true,
      },
    },

    computed: {
      attributes(): EmbedAttributes {
        return this.elem.attributes;
      },
    },
  });
</script>

<style lang="scss" scoped>
  // responsive iframe for youtube embed
  // cause oembed uses wrong dimensions
  .app-embed--youtube {
    position: relative;
    overflow: hidden;
    width: 100%;
    padding-top: 56.25%;

    :deep() {
      iframe {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        width: 100%;
        height: 100%;
      }
    }
  }
</style>
